import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Bell, BellOff } from 'lucide-react';
import { useNotifications } from '../context/NotificationContext';
import NotificationDropdown from './NotificationDropdown';

const NotificationBadge = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, right: 0 });
  const buttonRef = useRef(null);
  const { unreadCount, notificationsMuted } = useNotifications();

  useEffect(() => {
    if (isDropdownOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 8,
        left: rect.left,
        right: null, 
      });
    }
  }, [isDropdownOpen]);

  return (
    <>
      <div className="relative" ref={buttonRef}>
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className={`
            relative p-2 rounded-lg transition-all duration-200 
            text-gray-500 dark:text-gray-400
            hover:text-indigo-600 dark:hover:text-indigo-400
            hover:bg-indigo-50 dark:hover:bg-indigo-900/20
            ${isDropdownOpen ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/20 dark:text-indigo-400' : ''}
          `}
          title={
            notificationsMuted
              ? 'Notifications muted for testing (use sidebar to turn on)'
              : 'Notifications'
          }
        >
          {notificationsMuted ? (
            <BellOff className="w-5 h-5 text-amber-600 dark:text-amber-400" />
          ) : (
            <Bell className="w-5 h-5" />
          )}
          {!notificationsMuted && unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[18px] h-4 px-1 flex items-center justify-center bg-gradient-to-r from-red-500 to-rose-600 text-white text-[10px] font-bold rounded-full border-2 border-white dark:border-slate-900 shadow-lg animate-pulse">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>
      </div>

      {isDropdownOpen && createPortal(
        <NotificationDropdown 
          isOpen={isDropdownOpen} 
          onClose={() => setIsDropdownOpen(false)}
          position={position}
        />,
        document.body
      )}
    </>
  );
};

export default NotificationBadge;
